__turbopack_context__.v({
  "destinationName": "TopDestinationCard-module-scss-module__shv_5q__destinationName",
  "fallback": "TopDestinationCard-module-scss-module__shv_5q__fallback",
  "gradiant": "TopDestinationCard-module-scss-module__shv_5q__gradiant",
  "image": "TopDestinationCard-module-scss-module__shv_5q__image",
  "imageHidden": "TopDestinationCard-module-scss-module__shv_5q__imageHidden",
  "orangeBar": "TopDestinationCard-module-scss-module__shv_5q__orangeBar",
  "overlay": "TopDestinationCard-module-scss-module__shv_5q__overlay",
  "root": "TopDestinationCard-module-scss-module__shv_5q__root",
});
